import Header from "./Header";
import ModelEditBody from "./ModelEditBody";
import ModelFooterButtons from "./ModelFooterButtons";

export default {
  Header,
  ModelEditBody,
  ModelFooterButtons
};



// WEBPACK FOOTER //
// ./src/Core/Components/ModalParts/index.js